import { HealthToolCardData } from 'components/HealthToolsCards/HealthToolCard';
import HealthTools from './HealthTools';
import HealthToolsSurveyScreen from './Survey/HealthToolsSurveyScreen';
import { vyncaCard, vyncaRouteData } from './Cards/vynca';
import { myStrengthCard, myStrengthRouteData } from './Cards/myStrength';
import { diabetesCard, preventDiabetesRouteData } from './Cards/preventDiabetes';
import { RouteData } from 'screens/navigation';
import Config from 'react-native-config';

const getHealthToolsData = () => {
  const toolsData: HealthToolCardData[] = [];

  if (Config.MYSTRENGTH_HEALTH_TOOL_ENABLED === 'enabled') {
    toolsData.push(myStrengthCard);
  }

  toolsData.push(vyncaCard);

  if (Config.PREDIABETES_HEALTH_TOOL_ENABLED === 'enabled') {
    toolsData.push(diabetesCard);
  }

  return toolsData;
};

const healthToolsRouteData: RouteData = {
  component: HealthTools,
  componentName: 'HealthTools',
  crumbLabel: 'Health Tools',
  display: 'block',
  exact: true,
  icon: 'HealthTool',
  includeBanner: true,
  includeCrumbs: true,
  path: '/u/health-tools',
  sidenav: true,
  sidenavIcon: 'SNavHealthTools',
  sideNavOrder: 7,
  subMessage: 'Resources to help you live a healthy life',
  title: 'Health Tools'
};

const healthToolsSurveyRouteData: RouteData = {
  path: '/u/health-tools/survey',
  component: HealthToolsSurveyScreen,
  componentName: 'HealthToolsSurveyScreen',
  title: 'Health Tools',
  crumbLabel: 'Health Tools Survey',
  exact: true,
  includeDefaultLayout: true,
  includeBanner: true,
  includeCrumbs: true,
  icon: 'HealthTool'
};

export const getScreensOfHealthTools = (): RouteData[] => {
  const screens: RouteData[] = [];

  screens.push(healthToolsRouteData);
  screens.push(healthToolsSurveyRouteData);

  if (Config.MYSTRENGTH_HEALTH_TOOL_ENABLED === 'enabled') {
    screens.push(...myStrengthRouteData);
  }

  screens.push(...vyncaRouteData);

  if (Config.PREDIABETES_HEALTH_TOOL_ENABLED === 'enabled') {
    screens.push(...preventDiabetesRouteData);
  }

  return screens;
};

export const screensOfHealthToolsCards = getScreensOfHealthTools();
export const HealthToolsData = getHealthToolsData();
